import styled from 'styled-components';

export const Wrapper = styled.div<{ zoom: number }>`
    height: ${({ zoom }) => {
        switch (zoom) {
            case 0.6:
                return '184px';
            case 1:
                return '236px';
            case 1.4:
                return '315px';
            case 1.8:
                return '392px';
            case 2.2:
                return '545px';
            case 2.6:
                return '622px';
            default:
                return '236px';
        }
    }};
    width: 136px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 16px;
`;

export const StyledInput = styled.label`
    background: #eeeeee;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    line-height: 16px;

    & svg {
        margin-bottom: 9px;
    }

    & input {
        display: none;
    }

    &:hover {
        color: #0781d7;

        & svg path {
            fill: #0781d7;
            fill-opacity: 1;
        }
    }
`;
